






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class InputLabel extends Vue {
  @Prop({ type: String, default: '' }) readonly inputFor?: string
}
